import {coordsToKey} from "../utils/coords/coordsToKey";

export const FIELD_CENTRAL_HEX_KEY = coordsToKey(0, 0);